// Overrides the signed-in avatar's brand color in the <shopify-account> web component.
//
// The key inner element (#shopify-element-wrapper) declares its own
// --shop-brand-color inside the open shadow root, so an inherited value (even
// !important) can't override it. We inject an adopted stylesheet that targets
// that element directly.
//
// customElements.whenDefined() resolves when the class is *registered*, which can
// be before any instance is upgraded and its shadowRoot is attached. So we wait
// for the shadowRoot to exist, then keep our sheet applied via a MutationObserver
// in case the component re-renders or reassigns its adoptedStyleSheets.
(function () {
  if (typeof CSSStyleSheet === "undefined") return;

  var sheet = new CSSStyleSheet();
  sheet.replaceSync(
    "#shopify-element-wrapper { --shop-brand-color: #000 !important; }" +
      ".account-button--shop-customer { --ring-width: 1px !important; }" +
      ".account-button { --clamped-avatar-size: 16px !important; }" +
      "@media (min-width: 1200px) { .account-button { --clamped-avatar-size: 18px !important; } }",
  );

  function apply(root) {
    if (root.adoptedStyleSheets.indexOf(sheet) === -1) {
      root.adoptedStyleSheets = [].concat(root.adoptedStyleSheets, sheet);
    }
  }

  // Every <shopify-account> on the page, not just the first: the header bar and
  // the mobile menu drawer each render one, and they upgrade independently.
  function brand(host) {
    if (host.__brandedAccount) return;
    host.__brandedAccount = true;
    var tries = 0;
    (function waitForRoot() {
      if (host.shadowRoot) {
        apply(host.shadowRoot);
        new MutationObserver(function () {
          apply(host.shadowRoot);
        }).observe(host.shadowRoot, { childList: true, subtree: true });
        return;
      }
      if (tries++ < 200) requestAnimationFrame(waitForRoot);
    })();
  }

  function start() {
    var hosts = document.querySelectorAll("shopify-account");
    for (var i = 0; i < hosts.length; i++) brand(hosts[i]);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("shopify-account").then(start);
  } else {
    start();
  }
})();
